import baseAdmission from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:baseAdmission,
      name:'baseAdmission'
    },
  ]
};
